// extracted by mini-css-extract-plugin
export default {"root":"FieldNumberInputWithoutNegative_root__0ygQe","inputError":"FieldNumberInputWithoutNegative_inputError__GFiLg"};